import styled from 'styled-components';
import {theme} from "@/components/features/theme/theme";

export const StyledImagePlaceHolder = styled.section`
    margin-top: 100px;
    margin-bottom: 100px;
    background: ${props => props.color || 'white'};

    &.place {
        @media (max-width: 992px) {
            display: none;
        }
    }

    @keyframes pulse {
        0% {
            r: 14px;
        }
        50% {
            r: 20px;
        }
        100% {
            r: 14px;
        }
    }

    .position-relative {
        svg {
            width: 100%;
            height: 100%;
            text{
                opacity: 0;
                transition: ${theme.transition};
            }
            a {
                position: relative;
				&:hover{
					text{
						opacity: 1;
					}
				}
            }
			
			

            circle {
                animation: pulse 2s infinite ease-in-out;
            }
        }
		
		
		@media(max-width: 767px){
			overflow-x: scroll;
			svg{
                max-width: 800px;
                width: auto;
			}
		}
    }

    &.version {
        margin-top: 0;
        margin-bottom: 0;
        padding-top: 200px;
        padding-bottom: 200px;

        @media (max-width: 767px) {
            padding-top: 120px;
            padding-bottom: 120px;
        }
    }

    .image-wrapper {
        position: relative;
        padding-top: calc(557 / 1170 * 100%);

        &.main-stream {
            padding-top: calc(264 / 1170 * 100%);
        }
    }
`;
